import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'MeinDienst', // Used in module configurations
  moduleId: MODULE_ID, // Used as identifier for vuex module
  api: 'myduties', // path of ui

  routeHandler,
};

export default module;
